import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const RequestInfo = styled.div`
  @media (max-width: 640px) {
    display: flex;
    flex-direction: column;
    align-content: center;
    gap: 1rem;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-content: center;
    gap: 1rem;
  }
`;

export const Asunto = styled.div`
  @media (max-width: 640px) {
    font-size: 0.875rem;
  }
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-self: start;

  &:hover {
    border-radius: 10px;
    background-color: ${(props) => props.hoverBg};
  }

  @media (max-width: 640px) {
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 0.875rem;
  }
`;

export const InformationRow = styled.div`
  display: grid;
  grid-template-columns: 25% 10% auto;
  grid-gap: 20px;
  font-size: 14px;
`;

export const EncuestaSolicitud = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  border: 1px solid transparent;
  border-radius: 10px;
  width: 100%;

  &:hover {
    background-color: ${(props) => props.hoverBg};
  }

  @media (max-width: 640px) {
    padding-left: 12px;
    padding-right: 12px;
    font-size: 0.875rem;
  }
`;

export const Encuesta = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  padding: 0rem 6rem;
  font-size: 16px;
  gap: 5px;
`;

export const EncuestaForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const EncuestaBtn = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 2px solid transparent;
  border-radius: ${(props) => props.checked && "50%"};
  cursor: pointer;
  background-color: ${(props) => props.checked && "#3948ff"};
  color: ${(props) =>
    props.checked ? "white" : props.colorGray ? "gray" : "darkslategray"};

  &:hover {
    background-color: #3948ff;
    color: white;
    border-radius: 50%;
  }

  &:focus {
    outline: none;
  }
`;

export const Observaciones = styled(TextareaAutosize)`
  border: 1px solid #dce6e6;
  border-radius: 5px;
  font-size: 13px;
  min-height: 60px;
  text-justify: start;
  align-self: flex-start;
  width: 100%;
  padding: 3px;
  margin-top: 8px;

  &:focus {
    outline: none;
    border-color: #787878;
  }
`;

export const EncuestaSubmit = styled.button`
  /* flex items-center justify-center px-4 py-1 bg-green-300 rounded-md mt-2 */
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  background-color: #3948ff;
  border-radius: 7px;
  margin-top: 0.75rem;
  color: white;

  &:hover {
    background-color: white;
    color: #3948ff;
    border-color: #3948ff;
  }

  &:focus {
    outline: none;
  }
`;

export const ThumbImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const Dash = styled.p`
  text-align: center;
`;

export const TabButton = styled.button`
  background-color: ${(props) => (props.isActive ? "#FFFFFF " : props.bg)};
  border-width: ${(props) =>
    props.isActive ? "1px 1px 0px 1px" : "1px 1px 1px 1px"};
  margin-top: ${(props) => (props.isActive ? "-1rem" : "")};
  border-color: ${(props) => props.borderColor};

  :hover {
    background-color: white;
  }

  @media (max-width: 640px) {
    font-size: 0.65rem;
    padding: 2px;
  }

  @media (max-width: 768px) {
    font-size: 0.775rem;
    padding: 5px;
  }
`;

export const Tab = styled.div`
  @media (max-width: 640px) {
    padding: 8px;
  }
`;
